import { observer } from 'mobx-react';
import React from 'react';
import UserSettings from '../../common/UserSetting';

const VGSUserSettings = () => {
  return <UserSettings />;
};

export default observer(VGSUserSettings);
